<style lang="scss" scoped>
.progress-info-box {
  box-sizing: border-box;

  display: flex;

  width: 6.68rem;
  padding: 0.4rem 0.52rem 0.24rem;

  background-color: #faf2e0;
  border-radius: 0.2rem;

  flex-direction: column;
  align-items: center;
}
.step-progress-wrapper {
  position: relative;

  width: 100%;
  padding-top: 0.4rem;
}
</style>

<template>
  <div class="progress-info-box">
    <step-title :title="stageInfo.stageStatusDesc"></step-title>
    <div class="step-progress-wrapper">
      <step-progress-box
        v-for="item in stageInfo.ruleDescDtoList"
        :key="item.ruleId"
        :rule-info="item"
      ></step-progress-box>
    </div>
  </div>
</template>

<script>
import StepTitle from './StepTitle'
import StepProgressBox from './StepProgressBox'
export default {
  components: {
    StepTitle,
    StepProgressBox
  },
  props: {
    stageInfo: {
      type: Object,
      required: true
    }
  }
}
</script>
